import Phaser from 'phaser';
import { DEFAULT_GAME_CONFIG, GAME_WIDTH, GAME_HEIGHT } from './scenes/gameConfig';
import { App } from '@capacitor/app';
import { pauseBgm, resumeBgm, stopAllSe } from './utils/audioManager';
import { BootScene } from './scenes/BootScene';
import { TitleScene } from './scenes/TitleScene';
import { CharacterSelectScene } from './scenes/CharacterSelectScene';
import { BattleScene } from './scenes/BattleScene';
import { ResultScene } from './scenes/ResultScene';
import { DifficultySelectScene } from './scenes/DifficultySelectScene';
import { SettingsScene } from './scenes/SettingsScene';
import { ModeSelectScene } from './scenes/ModeSelectScene';
import { BattleStatsScene } from './scenes/BattleStatsScene';
import { BattleModeSelectScene } from './scenes/BattleModeSelectScene';
import { SpriteTestScene } from './scenes/SpriteTestScene';
import { SurvivalExpAllocationScene } from './scenes/SurvivalExpAllocationScene';
import { SurvivalResultScene } from './scenes/SurvivalResultScene';
import { TournamentSetupScene } from './scenes/TournamentSetupScene';
import { TournamentBracketScene } from './scenes/TournamentBracketScene';
import { TournamentResultScene } from './scenes/TournamentResultScene';
import { AICharacterEditScene } from './scenes/AICharacterEditScene';
import { VersusSelectScene } from './scenes/VersusSelectScene';
import { StageSelectScene } from './scenes/StageSelectScene';
import { AchievementScene } from './scenes/AchievementScene';
import { DebugScene } from './scenes/DebugScene';

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  width: DEFAULT_GAME_CONFIG.width,
  height: DEFAULT_GAME_CONFIG.height,
  backgroundColor: DEFAULT_GAME_CONFIG.backgroundColor,
  parent: 'game-container',
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: GAME_WIDTH,
    height: GAME_HEIGHT,
    fullscreenTarget: 'game-container',
  },
  scene: [BootScene, TitleScene, BattleModeSelectScene, VersusSelectScene, ModeSelectScene, CharacterSelectScene, DifficultySelectScene, BattleScene, ResultScene, SettingsScene, BattleStatsScene, SpriteTestScene, SurvivalExpAllocationScene, SurvivalResultScene, TournamentSetupScene, TournamentBracketScene, TournamentResultScene, AICharacterEditScene, StageSelectScene, AchievementScene, DebugScene],
  dom: {
    createContainer: true,
  },
  render: {
    pixelArt: DEFAULT_GAME_CONFIG.pixelArt,
  },
};

new Phaser.Game(config);

// バックグラウンド移行時にBGM・SEを停止し、復帰時にBGMを再開する
// @capacitor/app はネイティブ(Android/iOS)とWeb両方で確実に動作する
App.addListener('appStateChange', ({ isActive }) => {
  if (!isActive) {
    pauseBgm();
    stopAllSe();
  } else {
    resumeBgm();
  }
});
